// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1EgpF","info":"PatientInfo_info__xKC6_"};